import { createContext } from "react";

export interface ConnectedTeamData {
  teamId: string;
  name: string;
  logoUrl?: string;
  ticketCount: number;
}

export interface CurrentTeamData {
  teamId: string;
  name: string;
  logoUrl?: string;
}

export interface TeamSwitcherData {
  connectedStoresHaveTickets: boolean;
  connectedStores: ConnectedTeamData[];
  setCurrentTeam: (teamId: string) => void;
  currentTeam: CurrentTeamData;
  addStore: () => void;
}

export const TeamDataContext = createContext<TeamSwitcherData | undefined>(
  undefined,
);
